import { useTranslation } from 'react-i18next';
import { BannerStyles } from './Styles';

type Props = {
  margin?: boolean;
  title?: string;
};

export const Banner = ({ margin = false, title = 'ocr' }: Props) => {
  const { t } = useTranslation();

  return (
    <BannerStyles fontSize="16" forwardedAs="span" $margin={margin} semibold>
      {t(`${title}`)}
    </BannerStyles>
  );
};
